import { useState, useEffect } from 'react';

import { useGlobalDialog } from "../../Store/DialogManager";

import styled from 'styled-components';
import { IconDeviceFloppy } from '@tabler/icons-react';

import DateHelper from '../../Utilities/Helpers/DateHelper';

import { ButtonType } from '../../Utilities/Enums/ButtonTypeEnum';
import { CachingEnum } from '../../Utilities/Enums/CachingEnum';
import { InstanceAutoBackupsField } from '../../Utilities/Enums/ParametersEnum';

import CustomButton from '../../CustomViews/Elements/CustomButton';
import CustomCheckbox from '../../CustomViews/Elements/CustomCheckbox';
import AutoCompleteDropdown from '../../CustomViews/Elements/AutoCompleteDropdown';
import FormTimePicker from '../../CustomViews/Elements/FormTimePicker';

import { BackupConfigModalInterface } from '../../Models/InstanceManagement/InstanceManagement';

const ModalContentContainer = styled.div <{ $darkMode?: boolean; }>`
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
    // width: 20vw;
`;

export default function BackupConfigModal(props: BackupConfigModalInterface) {
    const { setDialogContent, setOpenGlobalDialog } = useGlobalDialog();
    let { instanceName, autoBackupConfig, previewAutoBackupConfig, setautoBackupConfig, setpreviewAutoBackupConfig, openBackupConfigModal, setopenBackupConfigModal, handleSubmitBackupConfig, DropdownData, dropdownFetchStatus } = props;

    //Use States
    let [errorMessages, setErrorMessages]: any = useState({});

    const enabledProps = {
        name: InstanceAutoBackupsField.ENABLED,
        title: 'Enable scheduled automatic backups',
        fieldValue: autoBackupConfig?.[InstanceAutoBackupsField.ENABLED] ?? false,
        checkboxType: ButtonType.PRIMARY,
        // required: requiredFields?.find((field: any) => field.keyName == InstanceAutoBackupsField.ENABLED)?.keyName != null,
        errorMessages: errorMessages,
        handleOnChange: (selectedValue: any) => {
            if(setautoBackupConfig) {
                setautoBackupConfig(prev => ({ ...prev, [InstanceAutoBackupsField.ENABLED]: selectedValue }));
            }
        },
    },
        frequencyProps = {
            name: InstanceAutoBackupsField.FREQUENCY,
            title: 'Frequency',
            fieldValue: autoBackupConfig?.[InstanceAutoBackupsField.FREQUENCY] ?? 0,
            options: DropdownData?.[CachingEnum.FREQUENCY_LIST] ?? [],
            isLoadingDropdown: dropdownFetchStatus ?? false,
            disabled: !autoBackupConfig?.[InstanceAutoBackupsField.ENABLED],
            // required: requiredFields?.find((field: any) => field.keyName == InstanceAutoBackupsField.FREQUENCY)?.keyName != null,
            errorMessages: errorMessages,
            handleOnChange: (selectedValue: any) => {
                if(setautoBackupConfig) {
                    setautoBackupConfig(prev => ({ ...prev, [InstanceAutoBackupsField.FREQUENCY]: selectedValue?.id ?? 0 }));
                }
            },
        },
        preferredTimeProps = {
            name: InstanceAutoBackupsField.PREFERRED_TIME,
            title: 'Preferred Time (server / UTC+8)',
            fieldValue: autoBackupConfig?.[InstanceAutoBackupsField.PREFERRED_TIME] ?? '',
            disabled: !autoBackupConfig?.[InstanceAutoBackupsField.ENABLED],
            // required: requiredFields?.find((field: any) => field.keyName == InstanceAutoBackupsField.PREFERRED_TIME)?.keyName != null,
            errorMessages: errorMessages,
            handleOnChange: (a: any) => {
                let selectedTime: string | Date | null = null;

                if(a != null && a != "") {
                    selectedTime = DateHelper.getFormattedDate(new Date(a), "yyyy-MM-dd'T'HH:mm:ss");
                }

                if(setautoBackupConfig) {
                    setautoBackupConfig(prev => ({ ...prev, [InstanceAutoBackupsField.PREFERRED_TIME]: selectedTime }));
                }
            }
        },
        retentionDaysProps = {
            name: InstanceAutoBackupsField.RETENTION_DAYS,
            title: 'Retention',
            fieldValue: autoBackupConfig?.[InstanceAutoBackupsField.RETENTION_DAYS] ?? 0,
            options: DropdownData?.[CachingEnum.RETENTION_DAYS_LIST] ?? [],
            isLoadingDropdown: dropdownFetchStatus ?? false,
            disabled: !autoBackupConfig?.[InstanceAutoBackupsField.ENABLED],
            // required: requiredFields?.find((field: any) => field.keyName == InstanceAutoBackupsField.RETENTION_DAYS)?.keyName != null,
            errorMessages: errorMessages,
            handleOnChange: (selectedValue: any) => {
                if(setautoBackupConfig) {
                    setautoBackupConfig(prev => ({ ...prev, [InstanceAutoBackupsField.RETENTION_DAYS]: selectedValue?.id ?? 0 }));
                }
            },
        },
        destinationProps = {
            name: InstanceAutoBackupsField.DESTINATION,
            title: 'Destination',
            fieldValue: autoBackupConfig?.[InstanceAutoBackupsField.DESTINATION] ?? '',
            options: DropdownData?.[CachingEnum.DESTINATION_LIST] ?? [],
            isLoadingDropdown: dropdownFetchStatus ?? false,
            // disabled: !autoBackupConfig?.[InstanceAutoBackupsField.ENABLED],
            disabled: true,
            // required: requiredFields?.find((field: any) => field.keyName == InstanceAutoBackupsField.DESTINATION)?.keyName != null,
            errorMessages: errorMessages,
            handleOnChange: (selectedValue: any) => {
                if(setautoBackupConfig) {
                    setautoBackupConfig(prev => ({ ...prev, [InstanceAutoBackupsField.DESTINATION]: selectedValue?.id ?? '' }));
                }
            },
        };

    //Event Handlers
    const onCloseDialog = async (e: any = null) => {
        if(e) {
            e.preventDefault();
        }

        if(setopenBackupConfigModal) {
            setopenBackupConfigModal(false);
        }

        if(setautoBackupConfig) {
            setautoBackupConfig({...previewAutoBackupConfig});
        }

        setOpenGlobalDialog(false);
    }

    useEffect(() => {
        if(openBackupConfigModal) {
            setDialogContent({
                title: "Auto Backup Settings",
                subtitle: <span>Automatic backups for <b>{instanceName}</b>. Backups run against a read replica and never lock production.</span>,
                clearDialog: onCloseDialog,
                onCloseDialog: onCloseDialog,
                actionButtons: renderActionButtons(),
                children: renderDialogContent(),
                dialogClassName: 'backupConfigModal',
            });
        }
    }, [openBackupConfigModal, autoBackupConfig, errorMessages]);

    //Rendering Functions
    const renderActionButtons = () => {
        return <>
            <CustomButton
                btnType={ButtonType.CANCEL}
                title='Cancel'
                onClick={(e: any) => {
                    onCloseDialog(e);
                }} />

            <CustomButton
                btnType={ButtonType.SUCCESS}
                startIcon={<IconDeviceFloppy />}
                title='Save Settings'
                onClick={(e: any) => {
                    if(handleSubmitBackupConfig) {
                        handleSubmitBackupConfig();
                    }
                }} />
        </>
    }

    const renderDialogContent = () => {
        return <ModalContentContainer>
            <CustomCheckbox {...enabledProps} />
            <AutoCompleteDropdown {...frequencyProps} />
            <FormTimePicker {...preferredTimeProps} />
            <AutoCompleteDropdown {...retentionDaysProps} />
            <AutoCompleteDropdown {...destinationProps} />
        </ModalContentContainer>
    }

    return <></>
}
